/* @flow */

import { Request } from "shared/src/services/Requests";

import { SearchResult } from "shared/src/types/articlesearch/SearchResult";
import { CategoryRoot } from "shared/src/types/articlesearch/Category";

const RequestBuilder = new Request.Builder("searchdiscover", "articlesearch", true);

export type RequestSearchQuery = {
    query: string;
    country: string;
    language: string;
    storeId: string;
    customerId?: string | null;
    page?: number | null;
    rows?: number | null;
    restriction?: string | null;
    sorting?: string | null;
    profile?: string | null;
    debugQuery?: boolean | null;
    onlySearchable?: boolean | null;
    filter?: string[] | null;
    facets?: boolean | null;
    categories?: boolean | null;
    role?: string | undefined;
};

export type SuggestRequestQuery = {
    locale: string;
    country: string;
    storeId: string;
    query: string;
    amount?: number | null;
    profile?: string | null;
};

/**
 * We use these tokens to detect requests from crawlers etc. for monitoring
 * purposes. (Obviously this is very easy to reverse-engineer! The only purpose
 * is to get proper metrics, so it's fine.)
 */
function generateToken() {
    return Date.now().toString(36);
}

export function getSuggestions(query: SuggestRequestQuery): Promise<any> {
    const url = "/suggestions";
    return RequestBuilder.path(url, {}).header({ "X-SD-Token": generateToken() }).query(query).get();
}

export function getRestrictions(ids: Array<string>): Promise<any> {
    const url = "/restriction";
    return RequestBuilder.path(url, {}).header({ "X-SD-Token": generateToken() }).body({ ids }).retry().post();
}

export function doSearch(query: { [x: string]: any }): Promise<SearchResult> {
    const url = "/search";
    return RequestBuilder.path(url, {}).header({ "X-SD-Token": generateToken() }).query(query).retry().get();
}

export function getMainCategories(query: { [x: string]: any }): Promise<CategoryRoot> {
    const url = "/mainCategories";
    return RequestBuilder.path(url, {}).header({ "X-SD-Token": generateToken() }).query(query).retry().get();
}

export default { getSuggestions, getRestrictions, doSearch, getMainCategories };
